import { ColumnFilter } from './ColumnFilter'; // Assuming you have this custom filter component

// Function to format numbers as currency, e.g., $100.00
function currencyFormat(value) {
    return `$${parseFloat(value).toFixed(2)}`;
}

// Function to format dates (if you have any date fields)
function dateFormat(value) {
    let objectDate = new Date(value);
    let day = ("0" + objectDate.getDate()).slice(-2);
    let month = ("0" + (objectDate.getMonth() + 1)).slice(-2);
    let year = objectDate.getFullYear();

    return day + "/" + month + "/" + year;
}

export const COLUMNS = [
    {
        Header: 'Repair Order ID',
        Footer: 'Repair Order ID',
        accessor: 'RepairOrderID',
        Filter: ColumnFilter,
        disableFilters: true // Disable filters if not needed for this column
    },
    {
        Header: 'رقم اللوحة',
        Footer: 'Vehicle ID',
        accessor: 'vehicle.LicensePlate',
        Filter: ColumnFilter,
    },
    {
        Header: 'الزبون',
        Footer: 'Customer ID',
        accessor: 'customer.FirstName',
                Filter: ColumnFilter,
    },
    {
        Header: 'تاريخ الصيانة',
        Footer: 'Repair Date',
        accessor: 'RepairDate',
        Filter: ColumnFilter,
        Cell: ({ value }) => dateFormat(value), // Format the repair date
    },
    {
        Header: 'التكلفة',
        Footer: 'Total Cost',
        accessor: 'TotalCost',
        Filter: ColumnFilter,
        Cell: ({ value }) => currencyFormat(value), // Format the total cost as currency
    },
    {
        Header: 'حالة الصيانة',
        Footer: 'Repair Status',
        accessor: 'RepairStatus',
        Filter: ColumnFilter,
    },
    {
        Header: 'حالة الدفع',
        Footer: 'Status',
        accessor: 'Status',
        Filter: ColumnFilter,
    },
   
];
